import { __decorate } from "tslib";
import notError from 'not-error/src/error.browser';
import Reporter from '../reporter';
import * as CONST from '../const';
import Reportable from '../decorators/reportable';
import DefaultReturn from '../decorators/defaultReturn';
import CalculatorLoaderStandart from './loader.standart';
class Calculator {
    hiddenProperties = new Set();
    data;
    options;
    loader;
    defaultProject = {
        image: '',
        properties: new Map()
    };
    constructor(options, data) {
        this.data = data;
        this.options = options;
        this.loader = new CalculatorLoaderStandart(this.options);
    }
    setConfig(data) {
        this.data = data;
    }
    getName() {
        return this.options.name;
    }
    getAllHiddenProperties() {
        return Array.from(this.hiddenProperties);
    }
    isPropertyHidden(propertyName) {
        return this.hiddenProperties.has(propertyName);
    }
    hideProperty(propertyName) {
        this.hiddenProperties.add(propertyName);
    }
    showProperty(propertyName) {
        this.hiddenProperties.delete(propertyName);
    }
    showAllProperties() {
        this.hiddenProperties.clear();
    }
    isDigital() {
        if (this.data) {
            return this.data.digital;
        }
        else {
            return CONST.DEFAULT_DIGITAL;
        }
    }
    async load() {
        if (this.data && Object.keys(this.data).length > 0) {
            return this.data;
        }
        else {
            this.data = await this.loader.load();
            if (typeof this.data !== 'undefined') {
                this.buildDefaultProject();
                return this.data;
            }
            else {
                throw new Error('Calculator config is undefined');
            }
        }
    }
    getSteps() {
        if (typeof this.data === 'undefined') {
            return [];
        }
        else {
            return this.data.steps;
        }
    }
    buildDefaultProject() {
        if (this.data) {
            //image
            this.defaultProject.image = this.detectDefaultImage();
            //properties
            this.data.steps.forEach((step) => {
                if ('face' === step.optionName) {
                    this.setDefaultProjectFaceCountByStep(step);
                    return;
                }
                if ('size' === step.optionName) {
                    this.setDefaultProjectSizeByStep(step);
                    return;
                }
                if (step.variants && Array.isArray(step.variants)) {
                    const id = this.extractDefaultValueId(step);
                    if (id > -1 && step.optionName) {
                        this.defaultProject.properties.set(step.optionName, id);
                        const variant = this.getPropertyValue(step.optionName, id);
                        if (variant && this.variantHasStillImage(variant)) {
                            this.defaultProject.image = variant.stillImage;
                        }
                    }
                }
                else if (step.default !== null && typeof step.default !== 'undefined') {
                    if (step.value && step.default !== step.value) {
                        // this.defaultProject.properties.set(step.optionName, -1);
                    }
                    else {
                        this.defaultProject.properties.set(step.optionName, step.default);
                    }
                }
            });
        }
    }
    variantHasStillImage(variant) {
        if (typeof variant !== 'undefined' && typeof variant !== 'boolean') {
            if (Object.prototype.hasOwnProperty.call(variant, 'stillImage')) {
                if (typeof variant.stillImage === 'string' && variant.stillImage.length > 3) {
                    return true;
                }
            }
        }
        return false;
    }
    extractDefaultValueId(step) {
        let id = -1;
        if (Array.isArray(step.variants)) {
            if (step.default && step.default.length > 10) {
                const variant = this.findVariantById(step, step.default);
                if (variant) {
                    id = variant.id;
                }
            }
        }
        return id;
    }
    getPropertyOnlyValueId(property) {
        const id = -1;
        const step = this.getPropertyStep(property);
        if (typeof step !== 'boolean' && step) {
            if (step.variants && !Array.isArray(step.variants)) {
                return step.variants.id;
            }
            if (step.id) {
                return step.id;
            }
        }
        return id;
    }
    setDefaultProjectFaceCountByStep(step) {
        this.defaultProject.facesCount = parseInt(step.default);
    }
    setDefaultProjectSizeByStep(step) {
        this.defaultProject.width = CONST.DEFAULT_SIZE_WIDTH;
        this.defaultProject.height = CONST.DEFAULT_SIZE_HEIGHT;
    }
    getDefaultProject() {
        return this.defaultProject;
    }
    getDefaultProjectPropertyId(property) {
        if (this.defaultProject.properties.has(property)) {
            const res = this.defaultProject.properties.get(property);
            if (typeof res === 'number' || typeof res === 'boolean') {
                return res;
            }
        }
        return -1;
    }
    findVariantById(step, _id) {
        if (Array.isArray(step.variants)) {
            return step.variants.find((variantData) => {
                return (variantData._id === _id);
            });
        }
        else {
            if (step.variants && typeof step.variants === 'object' && step.variants._id === _id) {
                return step.variants;
            }
            else {
                return false;
            }
        }
    }
    getVariantValue(step, id) {
        if (Array.isArray(step.variants)) {
            const res = step.variants.find((variantData) => {
                return (variantData.id === id);
            });
            if (res) {
                return res;
            }
        }
        else {
            if (step.variants && typeof step.variants === 'object' && step.variants.id === id) {
                return step.variants;
            }
        }
        return undefined;
    }
    getPropertyValue(property, id) {
        const step = this.getPropertyStep(property);
        if (typeof step !== 'boolean') {
            if (step.variants) {
                const val = this.getVariantValue(step, id);
                if (val) {
                    return val;
                }
            }
            else if (step.id) {
                return step;
            }
        }
        return false;
    }
    getPropertyStep(property) {
        if (this.data && Array.isArray(this.data.steps)) {
            const step = this.data.steps.find((step) => step.optionName === property);
            if (step) {
                return step;
            }
            Reporter.report(new notError('Step not found', { property }, null));
        }
        return false;
    }
    getDiscount() {
        if (this.data && this.data.priceoff) {
            return this.data.priceoff;
        }
        else {
            return CONST.PRICE_OFF;
        }
    }
    getAllAvailableProperties() {
        if (this.data && this.data.steps && Array.isArray(this.data.steps)) {
            return this.data.steps.map((step) => {
                return step.optionName;
            }).filter(name => !this.hiddenProperties.has(name));
        }
        else {
            return [];
        }
    }
    detectDefaultImage() {
        if (this.data) {
            if (this.data.stillImage && this.data.stillImage.length > 10) {
                return this.data.stillImage;
            }
        }
        return '';
    }
    formatPreservingRequired() {
        if (this.options && typeof this.options.preserveFormat) {
            return this.options.preserveFormat;
        }
        return CONST.PRESERVE_FORMAT;
    }
    isWithPaspartuOverflow() {
        return this.options.paspartuOverflow;
    }
    getPropertyStepAndValueStringified(propertyName, valueId) {
        if (!propertyName) {
            return [];
        }
        const step = this.getPropertyStep(propertyName);
        if (typeof step !== 'boolean' && step.optionName) {
            const value = this.getPropertyValue(step.optionName, valueId);
            let valueTitle = CONST.DEFAULT_VALUE_TITLE;
            if (typeof value !== 'undefined' && typeof value !== 'boolean' && Object.prototype.hasOwnProperty.call(value, 'title')) {
                valueTitle = value.title;
            }
            return [step.title, valueTitle];
        }
        else {
            return [];
        }
    }
}
__decorate([
    Reportable
], Calculator.prototype, "load", null);
__decorate([
    Reportable
], Calculator.prototype, "buildDefaultProject", null);
__decorate([
    Reportable
], Calculator.prototype, "extractDefaultValueId", null);
__decorate([
    Reportable
], Calculator.prototype, "getPropertyOnlyValueId", null);
__decorate([
    Reportable
], Calculator.prototype, "setDefaultProjectFaceCountByStep", null);
__decorate([
    Reportable
], Calculator.prototype, "findVariantById", null);
__decorate([
    DefaultReturn(false),
    Reportable
], Calculator.prototype, "getVariantValue", null);
__decorate([
    DefaultReturn(false),
    Reportable
], Calculator.prototype, "getPropertyValue", null);
__decorate([
    DefaultReturn(false)
], Calculator.prototype, "getPropertyStep", null);
__decorate([
    Reportable
], Calculator.prototype, "getDiscount", null);
export default Calculator;
